import { Check, Camera } from "lucide-react";

const items = [
  "Furniture",
  "Mattresses",
  "Household junk",
  "Appliances",
  "Boxes",
  "Office furniture",
  "Shelving",
  "Outdoor furniture",
  "Garage items",
  "General non-hazardous rubbish",
];

const WhatWeTake = () => (
  <section id="what-we-take" className="scroll-mt-28 bg-white py-16 md:py-24">
    <div className="container max-w-5xl">
      <h2 className="text-3xl md:text-4xl font-black text-[#1a1a1a] text-center mb-3">
        What Can We Take?
      </h2>
      <p className="text-center text-[#1a1a1a]/70 mb-12 max-w-xl mx-auto">
        Most everyday household and commercial rubbish can be removed.
      </p>

      <p className="text-xs font-black uppercase tracking-[0.18em] text-[#1a1a1a]/55 mb-5">
        Commonly removed
      </p>
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((item) => (
          <li
            key={item}
            className="flex items-center gap-3 rounded-xl border border-[#1a1a1a]/8 bg-card px-4 py-3.5 hover:border-[#F64A01] hover:bg-orange-soft transition-colors"
          >
            <span className="w-6 h-6 rounded-full bg-[#FDC00E]/25 flex items-center justify-center shrink-0">
              <Check className="w-3.5 h-3.5 text-success" strokeWidth={3} />
            </span>
            <span className="font-semibold text-[#1a1a1a] text-sm">{item}</span>
          </li>
        ))}
      </ul>

      <div className="mt-12 text-center">
        <h3 className="text-xl font-bold text-[#1a1a1a] mb-2">Not Sure?</h3>
        <p className="text-[#1a1a1a]/70 mb-6">Send us a photo and we'll let you know.</p>
        <a
          href="/#quote"
          className="inline-flex items-center justify-center gap-2 bg-[#1a1a1a] text-white px-8 py-4 text-lg font-bold rounded-md hover:bg-orange transition-colors"
        >
          <Camera className="w-5 h-5 shrink-0" />
          Send Photos for a Quote
        </a>
      </div>
    </div>
  </section>
);

export default WhatWeTake;
